/*global define, window, document*/
(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("Video", ["jquery", "Behaviors", "VideoPlayer"], factory);
    } else {
        root.Video = factory(root.jQuery, root.Behaviors, root.VideoPlayer);
    }
}(this, function ($, Behaviors, VideoPlayer) {
    /* Add our own extra classes here.
     */
    VideoPlayer.VideoPlayer_playpause.prototype.update_css_classes = (function (old_impl) {
        return function () {
            if (!this.parent.is_paused()) {
                this.$elem.addClass("is-VideoPlayer--was_played_once");
            }
        };
    }(VideoPlayer.VideoPlayer_playpause.prototype.update_css_classes));
    
}));